import { css } from '@emotion/react'
import { Color, FocusIndicator, Spacing, Theme } from '@opallabs/gem'

export const buttonOverrides = ({
  showingPlaceholder,
  theme,
}: {
  showingPlaceholder: boolean
  theme: Theme
}) =>
  css({
    blockSize: 36,
    justifyContent: 'start',
    paddingInline: Spacing.S,
    width: '100%',

    '.lapidary-button-contents': {
      overflow: 'hidden',
      textAlign: 'start',
      width: '100%',
    },

    '.lapidary-button-text': {
      color: showingPlaceholder
        ? Color[theme]['Text/Secondary']
        : Color[theme]['Text/Links'],
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'none',
      width: 'calc(100% - 55px)',
    },

    '&[aria-expanded="false"]:hover:enabled': {
      borderColor: 'transparent',

      '&:before': {
        backgroundColor: 'unset',
      },
    },

    '&[aria-expanded="true"]': {
      borderColor: Color[theme]['Strokes/Primary-2'],

      '&:enabled:before': {
        backgroundColor: 'unset',
      },
    },

    '&:focus, &:focus-visible': {
      ...FocusIndicator[theme],
    },

    '&:disabled': {
      cursor: 'text',
      opacity: 1,
    },
  })

export const popoverWrapper = css({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 12px',
  rowGap: 12,
  width: 284,
})

export const popoverFooter = (theme: Theme) =>
  css({
    display: 'flex',
    columnGap: 8,
    justifyContent: 'flex-end',
    height: 40,
    alignItems: 'center',
    padding: '0px 8px',
    backgroundColor: Color[theme].Surface.N200,
  })

export const urlFieldLabel = css({
  fontWeight: 600,
})

export const urlFieldInput = css({
  paddingRight: 50,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
})

export const urlCopyButton = css({
  position: 'absolute',
  top: 46,
  right: 16,
  width: 48,
})
